export default __webpack_public_path__ + "static/media/Cushion@2x.27f98acd.png";